import * as React from 'react';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RouterProps, withRouter } from 'react-router';
import { State } from '../../redux/state';
import { LProps, withLocalization } from '../../utils/wrappers';
import { Entity, Competition } from '../../userApi';
import { makeEntityPath } from '../../utils/routerHelper';
import ScoreboardCampuses from '../../shared/ScoreboardCampuses';
import { userUniversity } from '../../redux/selectors';
import actions from '../../redux/actions';
import { asPage } from '../../utils/wrappers/asPage';
import Footer from '../../shared/Footer';
import { campusLabelFor } from '../../utils/competitionLabels';

interface Props {
  university: Entity;
  competition: Competition;
  initializeDepartmentsPage: () => void;
}

class DepartmentsPage extends React.Component<LProps<Props> & RouterProps> {

  public componentWillMount() {
    const { initializeDepartmentsPage } = this.props;
    initializeDepartmentsPage();
  }

  public render() {
    const {
      university, t, competition
    } = this.props;
    const campusLabel = campusLabelFor(competition, t('Campus'));
    return (
      <div id="cc__departments" className="cc__page__column_content">
        <div className="cc__page__column_content__left">
          {university &&
            <div>
              <h4>{`Your ${campusLabel}`}</h4>
              <Link to={makeEntityPath(competition.id, university, t)}>{university.name}</Link>
              <p className="cc__lighttext" style={{ marginTop: '0.75rem' }}>
                {`Open your ${campusLabel.toLowerCase()} page for totals, division rankings, and activity.`}
              </p>
            </div>
          }
          {!university &&
            <div className="cc__teams__no_team">
              <h2>{`Choose your ${campusLabel}`}</h2>
              <p className="cc__lighttext cc__bigtext">
                {`Your ${campusLabel.toLowerCase()} is set when you join a division.`}
              </p>
            </div>
          }
          <Footer />
        </div>
        <div className="cc__page__column_content__right">
          <div className="cc__white_box">
            <h3 className="cc__darktext" style={{ marginBottom: '0.75rem' }}>{`${campusLabel} leaderboard`}</h3>
            <div className="cc__scoreboard">
              <ScoreboardCampuses />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State, _ownProps: LProps<RouterProps>): Partial<Props> => ({
  competition: state.competition,
  university: userUniversity(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  initializeDepartmentsPage: actions.initializeDepartmentsPage
}, dispatch);

export default asPage({})(compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withLocalization('teams')
)(DepartmentsPage));
